import { createFileRoute } from '@tanstack/react-router';
import { UserType } from '../../../types';
import { submissionRouteLoader } from '../../../utils/submission-route-loader';
import SurveySigner from '../../../components/pages/survey-signer';

export const Route = createFileRoute('/$accountSlug/$submissionId/signer')({
  ...submissionRouteLoader(UserType.SIGNER, (accountSlug, submissionId) => `/${accountSlug}/${submissionId}/signer`),
  component: SurveySigner,
});
